import { InputValueType } from '@/checkout-instore-legacy/product/typings'

export const allowedInputValueTypes: InputValueType[] = ['TEXT']
